module.exports = __webpack_public_path__ + "static/media/car_button_04.9687e2d0.png";